import type { Ref, SVGProps } from 'react'
import { cx } from '@/shared/lib'
import s from './BrandMark.module.css'

/** Ступени высоты знака: три — как у иконок, `xl` — марка на экранах до входа. */
export type BrandMarkSize = 'sm' | 'md' | 'lg' | 'xl'

export type BrandMarkProps = {
  size?: BrandMarkSize
  /** Доступное имя. Задано — знак смысловой; не задано — декоративный и скрыт от скринридера. */
  label?: string
  ref?: Ref<SVGSVGElement>
} & Omit<SVGProps<SVGSVGElement>, 'title' | 'children'>

/**
 * Знак «Mi» из «Meratech B2B icon system» (`brand/logo/meratech-mark.svg`): контур
 * в `currentColor`, поэтому цвет даёт контейнер, и в тёмной теме знак перекрашивать не нужно.
 * Геометрия кита: обводка 7 на поле 97×100, прямые концы и углы, квадрат — заливкой.
 */
export function BrandMark({ size = 'md', label, className, ref, ...rest }: BrandMarkProps) {
  return (
    <svg
      {...rest}
      ref={ref}
      viewBox="0 0 97 100"
      className={cx(s.root, s[size], className)}
      data-size={size}
      focusable="false"
      role={label ? 'img' : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeWidth="7"
        strokeLinecap="butt"
        strokeLinejoin="miter"
      >
        <path d="M62 3.5H3.5V96.5" />
        <path d="M14 52 33 75 52 50V96.5H88V33" />
      </g>
      <rect x="79" y="0" width="18" height="18" fill="currentColor" />
    </svg>
  )
}
